import React from 'react';
import { Info } from 'lucide-react';
import { useYearContext } from '../components/Layout.jsx';
import RichText from '../lib/RichText.jsx';
import { Empty } from '../components/states.jsx';

export default function Grading() {
  const { year } = useYearContext();
  const { note = '', blocks = [] } = year.grading || {};

  return (
    <>
      <div className="page-head">
        <h1>Známkování</h1>
        <p>Jak vzniká známka na vysvědčení.</p>
      </div>

      {note && (
        <div className="notice" style={{ marginBottom: blocks.length ? '2rem' : 0 }}>
          <Info size={18} aria-hidden="true" />
          <div><RichText text={note} /></div>
        </div>
      )}

      {blocks.length === 0 && !note && (
        <Empty title="Pravidla zatím nejsou zveřejněná">
          Doplním je, jakmile je budeme mít domluvená.
        </Empty>
      )}

      {blocks.length > 0 && (
        <div className="stack">
          {blocks.map((block, index) => (
            <section className="card" key={index}>
              {block.heading && (
                <div className="section-title"><h2 style={{ fontSize: '1.05rem' }}>{block.heading}</h2></div>
              )}
              <div className="prose" style={{ maxWidth: 'none' }}>
                <RichText text={block.body} />
              </div>
            </section>
          ))}
        </div>
      )}
    </>
  );
}
